import type { VFC } from 'react';
import { Flex } from 'antd';
import { Card } from 'components';
import { useManufacturers } from 'api/hooks/manufacturers/useManufacturers';
import { ManufacturersListFilter } from './components/Filter';
import { useManufacturersListFilterWithPagination } from './hooks/useManufacturersListFilterWithPagination.ts';
import { ManufacturersTable } from './components/Table';

export const ManufacturersList: VFC = () => {
  // State
  const { filter, pagination, setPaginationState } = useManufacturersListFilterWithPagination();

  // Fetch
  const { data: manufacturersResponse, isFetching: isFetchingManufacturers } = useManufacturers(
    {
      ...(filter?.search && { search: filter.search }),
      ...(filter?.commodity && { commodity: filter.commodity }),
      sort: filter?.sort,
      populate: ['meter_models'],
      page: pagination.current,
      pageSize: pagination.pageSize,
    },
    {
      onSuccess: data => {
        setPaginationState({ total: data?.meta?.pagination?.total });
      },
    },
  );

  return (
    <Flex vertical gap={16}>
      <Card>
        <ManufacturersListFilter />
      </Card>

      <Card>
        <ManufacturersTable
          isFetchingManufacturers={isFetchingManufacturers}
          manufacturersData={manufacturersResponse?.data ?? []}
        />
      </Card>
    </Flex>
  );
};
